import { EMPLOYEE_FLOW_STEPS } from "../../components/EmployeeFlow/Steps/employeeFlowSteps";
import {
  SAVE_BASIC_INFO_DETAILS_SUCCESS,
  SET_EMPLOYEE_FLOW_STAGE,
  SET_EMPLOYEE_FLOW_STAGE_SUCCESS,
  SET_SKIP_STAGING_API,
} from "../EmployeeFlow/employeeFlow.type";
import {
  LOGIN_SUCCESS,
  LOGOUT_USER_DETAILS_SUCCESS,
  SAVE_USER_DETAILS_SUCCESS,
  SET_NEW_PASSWORD_REQUEST,
  UPDATE_AUTH_USER_DETAILS,
} from "./login.type";

const initialState = {
  accessToken: null,
  user: null,
  companyId: null,
  stagingStage: null,
  stagingStageStatu: null,
  skipStagingApi: false,
  sessionExpired: false,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      return {
        ...state,
        accessToken: action.payload?.tokenDetails?.accessToken,
        user: action.payload?.dto,
        companyId: action.payload?.dto?.companyId,
        sessionExpired: true,
      };
    }
    case SAVE_USER_DETAILS_SUCCESS: {
      return {
        ...state,
        accessToken: action.payload?.tokenDetails?.accessToken,
        user: action.payload?.dto,
        companyId: action.payload?.dto?.companyId,
        sessionExpired: true,
      };
    }
    case SET_NEW_PASSWORD_REQUEST: {
      return {
        ...state,
        accessToken: action.payload?.tokenDetails?.accessToken,
        user: action.payload?.dto,
        companyId: action.payload?.dto?.companyId,
        sessionExpired: true,
      };
    }
    case UPDATE_AUTH_USER_DETAILS: {
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
        companyId: action.payload?.companyId || state.companyId,
      };
    }

    case SAVE_BASIC_INFO_DETAILS_SUCCESS: {
      return {
        ...state,
        companyId: action.payload?.id,
      };
    }
    case SET_EMPLOYEE_FLOW_STAGE: {
      return {
        ...state,
        stagingStage: action.payload,
      };
    }
    case SET_EMPLOYEE_FLOW_STAGE_SUCCESS: {
      return {
        ...state,
        stagingStageStatu: action.payload.dto,
      };
    }
    case "SESSION_EXPIRED":
      return {
        ...state,
        sessionExpired: true,
        accessToken: null,
        user: null,
        companyId: null,
        stagingStage: null,
        stagingStageStatu: null,
        skipStagingApi: false,
      };

    case LOGOUT_USER_DETAILS_SUCCESS: {
      return {
        ...state,
        accessToken: null,
        user: null,
        companyId: null,
        stagingStage: null,
        stagingStageStatu: null,
        skipStagingApi: false,
        sessionExpired: false,
      };
    }

    case "SET_COMPANY_APPROVAL_STATUS":
      return {
        ...state,
        stagingStageStatu: {
          ...state.stagingStageStatu,
          companyStatus: action.payload.companyStatus,
        },
      };

    case SET_SKIP_STAGING_API:
      return {
        ...state,
        skipStagingApi: action.payload,
      };

    default:
      return state;
  }
};
